import React from 'react';

export interface IErrorContext {
  enqueueError: (error: Error) => void;
}
export const ErrorContext = React.createContext({} as IErrorContext);
export const useErrorContext = () => React.useContext(ErrorContext);
